import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import History from './History';
import styles from './styles';

function mapStateToProps(state) {
  const {
    isLoading, histories, error, currentPage, totalPage,
  } = state.request;
  return {
    isLoading,
    histories,
    error,
    currentPage,
    totalPage,
  };
}

const Styled = withStyles(styles)(History);

export default connect(
  mapStateToProps,
)(Styled);
